import Route from '@ember/routing/route';
import { set, get } from '@ember/object';
import { service } from '@ember/service';
import Changeset from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import { validatePresence } from 'ember-changeset-validations/validators';

const contactValidation = {
  name: validatePresence({ presence: true, message: "Can't be blank" }),
};

export default Route.extend({
  abilities: service(),
  fundsService: service(),
  navbarSettings: service(),
  store: service(),

  beforeModel(transition) {
    if (this.abilities.noAbility('edit_contact')) {
      transition.abort();
    }
    set(this, 'navbarSettings.title', 'Add Contact');
    return this.fundsService.confirmValidFundToken();
  },

  model() {
    let record = this.store.createRecord('contact', {
      active: true,
    });
    return {
      record: record,
      changeset: new Changeset(
        record,
        lookupValidator(contactValidation),
        contactValidation,
      ),
    };
  },
});
